import useConvTag from "./use-conv-tag";
import useCustomerTag from "./use-customer-tag";

export default { useConvTag, useCustomerTag };

export { useConvTag, useCustomerTag };
